import React, { useMemo, useContext } from 'react';
import styled, { css } from 'styled-components';
import { FlexMiddle, Tooltip, ApproveIcon } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(FlexMiddle)`
  justify-content: flex-end;
`;

const ApproveButton = styled(ApproveIcon)`
  min-width: 26px;
  cursor: auto;

  ${({ $hasChangedAfterApprove }) =>
    $hasChangedAfterApprove &&
    css`
      circle {
        stroke: ${({ theme }) => theme.colors.disabled};
        fill: ${({ theme }) => theme.colors.disabled};
      }
    `}
`;

const isFilledJob = ({ dummy, actualIn, actualOut, jobTypeId }) => jobTypeId !== 1 || (!dummy && actualIn && actualOut);

const ApproveRenderer = ({ rowData, rowData: { approved, hasChangedAfterApprove, summarized } }) => {
  const { t } = useContext(ConfigContext);

  const tooltipBody = useMemo(
    () => (hasChangedAfterApprove ? t('hasChangedAfterApprove') : approved ? t('approved') : ''),
    [approved, hasChangedAfterApprove, t]
  );

  if (summarized) {
    return <></>;
  }

  return (
    <Wrapper>
      {isFilledJob(rowData) && approved && (
        <Tooltip body={tooltipBody}>
          <ApproveButton $isActive $hasChangedAfterApprove={hasChangedAfterApprove} $readOnly />
        </Tooltip>
      )}
    </Wrapper>
  );
};

export default ApproveRenderer;
